import { Component, OnInit, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Component({
  	selector: '[show-more]',
  	templateUrl: './show-more.component.html',
  	styleUrls: ['./show-more.component.scss']
})

export class ShowMoreComponent implements OnInit {
  	public expanded: boolean = false;
  	public shouldExpand: boolean = false;

  	constructor(private el: ElementRef, private renderer: Renderer2) { }

  	ngOnInit() {
  	}

  	ngAfterViewInit() {
  		if (this.el.nativeElement.offsetHeight > 83) {
  			this.shouldExpand = true;
  		}
  	}

  	toggle() {
  		this.expanded = !this.expanded;
  	}

}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/components/show-more/show-more.component.ts